import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { isWeb } from "@stepapp/core";
import { MMKV } from "react-native-mmkv";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  type PersistConfig,
  PURGE,
  persistReducer,
  persistStore,
  REGISTER,
  REHYDRATE,
  type Storage,
} from "redux-persist";

import appConfigReducer from "./appConfig";
import calendarReducer from "./calendar";
import draftReservationReducer from "./draftReservation";
import homeProfileReducer from "./homeProfile";
import notificationsReducer from "./notifications";
import userReducer from "./user";

export const reducer = combineReducers({
  appConfig: appConfigReducer,
  user: userReducer,
  notifications: notificationsReducer,
  homeProfile: homeProfileReducer,
  draftReservation: draftReservationReducer,
  calendar: calendarReducer,
});

const storage = new MMKV(isWeb ? undefined : { id: "customer-store" });

const reduxStorage = (): Storage => ({
  setItem: (key, value) => {
    storage.set(key, value);
    return Promise.resolve(true);
  },
  getItem: (key) => {
    const value = storage.getString(key);
    return Promise.resolve(value);
  },
  removeItem: (key) => {
    storage.delete(key);
    return Promise.resolve();
  },
});

const persistConfig: PersistConfig<ReturnType<typeof reducer>> = {
  key: "root",
  storage: reduxStorage(),
  whitelist: ["homeProfile", "appConfig"],
};

const store = configureStore({
  devTools: __DEV__,
  middleware: (getDefaultMiddleware) => {
    const middlewareArray = getDefaultMiddleware({
      serializableCheck: { ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER] },
    });

    return middlewareArray;
  },
  reducer: persistReducer(persistConfig, reducer),
});

export const persistedStore = persistStore(store);

export default store;
